<template>
    <img :src="imageSource" style="width: 100%"/>
</template>

<script>
    import {vIcon, vFileSelector} from '@/components/form';
    import Camera from '@/common/camera';

    export default {
        name: 'preview-form-step',
        inject: ['registerAction', 'stepKey', 'getContext'],
        components: {
            vIcon,
            vFileSelector,
        },
        props: {
            attributeName: {
                type: String,
                required: true,
            },
        },
        computed: {
            source() {
                return this.getContext().formData.source;
            },
            imageSource() {
                const {type, object} = this.source;
                if (type === 'camera') {
                    return object;
                }
                return URL.createObjectURL(object);
            },
        },
        methods: {
            submit() {
                const {type, object} = this.source;
                if (type === 'camera') {
                    return Camera.dataUrlToBlob(object);
                }
                return object;
            },
            register() {
                const action = {
                    attributeName: this.attributeName,
                    delegated: this.submit,
                };
                this.registerAction(this.stepKey, action);
            },
        },
        mounted() {
            this.register();
        },
    };
</script>
